<template>
<div class="chapter">
<div class="inner_page">
<h1 class="GFP_TOC_Header" epub:type="toc">Contents</h1>
<p class="GFP_TOC1"><a href="#/prologue"><span class="black">Prologue</span></a></p>
<p class="GFP_TOC"><a href="#/chapter"><span class="black">Autumn</span></a></p>
<p class="GFP_TOC"><span href="#/chapter2" title="Link target outside of Sample"><span class="black">Winter</span></span></p>
<p class="GFP_TOC"><span href="#/chapter4" title="Link target outside of Sample"><span class="black">Spring</span></span></p>
<p class="GFP_TOC"><span href="#/chapter6" title="Link target outside of Sample"><span class="black">Summer</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?29b0032c